<!-- <div class="modal-header pt-1 mb-1">
  <h3 class="mt-0 modal-title text-center mx-auto" id="modal-basic-title">
    <span class="d-inline-block align-middle ms-1" translate></span>
  </h3>
  <button class="btn-close text-white" (click)="modalManagerService.dismiss()"></button>
</div> -->
<div class="position-relative w-100 promo">
  <div class="container-promo flex-column flex-md-row d-flex">
    <div class="box-text text-white">
      <div class="text-center">
        <img class="logo" src="/assets/images/iko-logo.svg" alt="iko logo" />
      </div>
      <div class="first-title text-center" translate>BECOME A COACH</div>
      <div class="sub-title text-center" translate>IN FIVE DISCIPLINES:</div>
      <div class="list text-start">
        <ul>
          <li translate>Complete the coach certification online from the comfort of your home</li>
          <li translate>Certify students who take Evolution Courses in your discipline</li>
          <li translate>Become a freeride coach and Lead IKO Adventures - downwinders, boat trips and kite trips</li>
          <li translate>Become a wingfoil coach and join the International Wingfoil Organization (IWO) for free</li>
        </ul>
      </div>
      <div class="footer-title d-none d-lg-block" translate>Take your career to the next level.</div>
      <div class="footer-sub-title d-none d-lg-block" translate>Start your coach certification online today!</div>
    </div>
    <div class="box-image">
      <div class="inner-box w-100 h-100 text-center">
        <div class="first-title" translate>start</div>
        <div class="second-title" translate>your coach certification</div>
        <div class="third-title d-none d-md-block" translate>online today!</div>
        <img src="/assets/images/iko-promo-coach.jpg" alt="iko-promo-coach" />
        <div class="slogan-sub-image-1" translate>
          <div translate>Take your career</div>
          <div class="sub-title" translate>to the next level.</div>
        </div>
        <button class="btn btn-success mt-4 cta-button" (click)="openCourse()" translate>Start Course Online</button>
      </div>
    </div>
  </div>
  <div class="close-modal pointer d-flex justify-content-center align-items-center" (click)="service.close()">
    <i class="icon icon-times"></i>
  </div>
</div>
